import React from "react";

import CalendarIcon from "../../../../common/icons/integrations/CalendarIcon";
import GenericReconnectCard from "../GenericReconnectCard";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";

export default function CalendarReconnectCard({ controller, device }) {
  return (
    <GenericReconnectCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.calendar}
      IconTag={CalendarIcon}
      title={device.name}
      description="Reconnect to continue getting the best insights from your calendar."
    />
  );
}
